import React from "react";
import googleLogo from "../../assets/icons/google-logo.svg";
import microsoftLogo from "../../assets/icons/microsoft-logo.svg";

/**
 * Shared Google / Microsoft continue buttons for Login + Signup.
 */
const SocialAuthButtons = ({ onGoogle, onMicrosoft }) => {
  return (
    <div className="social-auth-buttons">
      <div className="social-auth-divider" role="separator">
        <span>Or continue with</span>
      </div>
      <div className="social-auth-buttons__row">
        <button
          type="button"
          className="social-auth-btn"
          onClick={onGoogle}
          aria-label="Continue with Google"
        >
          <img src={googleLogo} alt="" className="social-auth-btn__icon" />
          <span>Google</span>
        </button>
        <button
          type="button"
          className="social-auth-btn"
          onClick={onMicrosoft}
          aria-label="Continue with Microsoft"
        >
          <img
            src={microsoftLogo}
            alt=""
            className="social-auth-btn__icon social-auth-btn__icon--ms"
          />
          <span>Microsoft</span>
        </button>
      </div>
    </div>
  );
};

export default SocialAuthButtons;
